<style scoped lang="scss">
  .strengths{
    display: flex;
    margin-top: 30px;
    li{
      flex:1;
      text-align: center;
      border-right: 1px solid #eee;
      padding:0 40px;
      &:last-child{
        border: 0;
      }
      h4{
        font-size: 18px;
        margin-bottom: 10px;
        color:#014492;
      }
    }
  }
  .service_chan{
    margin-bottom: 20px;
    display: flex;
    overflow: auto;
    justify-content: space-around;
    li{
      width: 190px;
      height: 188px;
      //margin-right:100px;
      background: url("../../assets/img/产品及服务/fuwu.jpg") no-repeat!important;
      background-size: auto!important;
      .img{
        width: -moz-fit-content;
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
        padding-top: 20px;
        padding-bottom: 20px;
      }
      p{
        font-size: 16px;
        color:#4e4e4e;
        margin-bottom: 10px;
        width: -moz-fit-content;
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
      }
      .liaojie{
        width: -moz-fit-content;
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
        color:#959595;
        cursor: pointer;
      }
    }
    li:hover{
      background: url("../../assets/img/产品及服务/fuwu1.jpg") no-repeat!important;
      background-size: auto!important;
      p{
        color: #fff;
      }
      .liaojie{
        color: #fff;
      }
    }
    li:last-child{
      margin-right: 0;
    }
  }
  .download{
    display: flex;
    flex-wrap: wrap;
    border-left: 1px solid #E4E6EA;
    li{
      width:50%;
      padding:20px 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #E4E6EA;
      border-right: 1px solid #E4E6EA;
      font-size: 16px;
      cursor: pointer;
      &:nth-of-type(1){
        border-top: 1px solid #E4E6EA;
      }
      &:nth-of-type(2){
        border-top: 1px solid #E4E6EA;
      }
      &:hover{
        color:#014492;
      }
    }
    .btn-primary{
      font-size: 14px;
      span{
        margin-right: 7px;
      }
    }
    .mr41{
      display: block;
    }
    .mr42{
      display: none;
    }
  }
  .table{
    tr{
      td:first-child{
        background: #F6FAFD;
      }
    }
  }
  .c-title small{
    margin-top: 10px;
  }
  .required{
    font-size: 18px;
    background: none!important;
    margin-left: 0!important;
  }
  .desc{
    font-size: 16px;
  }
  .effect-lists1,.effect-lists{
    //display: block!important;
    justify-content: space-between;
    flex-wrap:wrap;
    overflow: auto;
  }
  .compose-type1{
    padding-bottom: 50px;
    background: url("../../assets/img/产品及服务/基因检测/bg.png") no-repeat;
    background-size: 100% 100%;
  }
  .effect-lists1 li{
    width: 261px!important;
    height: 262px!important;
  }
  @media
  screen and (max-width: 375px) and (min-width: 374px),
  screen and (max-width: 414px) and (min-width: 413px),
  screen and (max-width: 640px) and (min-width: 600px),
  screen and (min-width: 300px) and (max-width:400px)
  {
    .container100{
      margin-bottom: 20px!important;
    }
    .service_chan{
      justify-content:flex-start!important;
    }
    .effect-lists1{
      justify-content:center!important;
    }
  }
  .cons{
    display: none;
  }
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <div class="banner" v-if="!$route.meta.invisible && !$route.meta.invisibles">
      <div class="con"><img src="@/assets/img/设备及原料/仪器设备/banner.png" class="img-fluid"></div>
      <div class="cons"><img src="@/assets/img/一级标题Banner/仪器设备.jpg" class="img-fluid"></div>
      <div class="info"></div>
    </div>
    <section v-if="!$route.meta.invisible && !$route.meta.invisibles">
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container container100" style="margin-bottom: 100px;">
      <p class="desc">擎科生物始终秉承自主与创新精神，研发了一系列具有自主知识产权的技术、产品和仪器，现已搭建了全国领先的合成生物学基础平台、仪器研发中心、大数据分析等七大板块。拥有自主研发的自动化基因合成生产线，已结合AI、机器人等技术全新打造无人基因合成实验室。自主研发生产了768通道合成仪，拥有DNA/RNA合成仪，自动核酸提取仪，核酸纯化仪等多种仪器设备。正在向自动化和人工智能推进，以颠覆性创新思维助力科技发展，为合成生物学相关研究保驾护航。</p>
        <div class="con"><img src="@/assets/img/设备及原料/仪器设备/插图.png"></div>
        <div class="gene_img cons"><img src="@/assets/img/设备及原料/仪器设备/插图_2.png"></div>
      </div>
      <div class="container">
        <div class="c-title">智能制造<small>Intelligent Manufacturing</small></div>
        <div class="con">
          <ul class="effect-lists effect-lists1">
            <li v-for="(item, index) in types" :key="index" class="pointer" :class="{active: currentService === index}" @mouseover="currentService = index" @mouseout="currentService = -1" @click="$router.push(item.ref)">
              <img :src="`/static/img/zz_${item.img}${currentService===index ? '' : '_active'}.png`" style="margin-top: 0;">
              <!--            <p style="margin-top: 10px;">{{item.name}}</p>-->
            </li>
          </ul>
        </div>
        <div class="cons" style="margin-top: 20px;">
          <ul class="effect-lists effect-lists1">
            <li v-for="(item, index) in types" :key="index" class="pointer" :class="{active: currentService === index}"  @click="$router.push(item.ref)">
              <img :src="`/static/img/zz2_${item.img}${currentService===index ? '' : ''}.png`" style="margin-top: 0;width: 90px!important;height: 75px;">
              <p style="margin-top: 10px;">{{item.name}}</p>
            </li>
          </ul>
        </div>

      </div>
      <div class="compose-type1" style="margin-top: 100px;">
        <div class="container">
          <div class="c-title">擎科智能制造优势<small>Advantages of Tsingke intelligent manufacturing</small></div>
          <div class="con">
            <div class="neirong" style="display: flex">
              <div class="left ">
                <img src="@/assets/img/设备及原料/仪器设备/ys.png" class="img-fluid">
              </div>
              <div class="right">
                <div class="required">
                  <p class="mb20">1.配备多种安全防护设计，快捷、稳定、高效运行；</p>
                  <p class="mb20">2.数据结果精准，操作便利，灵活控制；</p>
                  <p class="mb20">3.满足不同合成规模的单条核酸产量，灵活满足各种生产需求；</p>
                  <p class="mb20">4.支持定制化设计、生产、安装，免费培训；</p>
                  <p class="mb20">5.24小时响应技术服务，7日无忧换新服务，365日免费售后服务，科研无忧。</p>
                </div>
              </div>
            </div>
          </div>
          <div class="cons">
            <div class="neirong" style="display: flex">
              <div class="right">
                <div class="required">
                  <p class="mb20">1.配备多种安全防护设计，快捷、稳定、高效运行；</p>
                  <p class="mb20">2.数据结果精准，操作便利，灵活控制；</p>
                  <p class="mb20">3.满足不同合成规模的单条核酸产量，灵活满足各种生产需求；</p>
                  <p class="mb20">4.支持定制化设计、生产、安装，免费培训；</p>
                  <p class="mb20">5.24小时响应技术服务，7日无忧换新服务，365日免费售后服务，科研无忧。</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="c-title">相关服务<small>Related services</small></div>
        <div class="con">
          <ul class="effect-lists service_chan">
            <li v-for="(item, index) in gene1" :key="index" class="pointer" :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1" @click="$router.push(item.ref)">
              <img :src="`/static/img/hx_${item.img}${currentType===index ? '' : '_active'}.png`" >
              <p style="margin-top: 10px;">{{item.name}}</p>
              <div class="liaojie" @click="$router.push(item.ref)">了解更多></div>
            </li>
          </ul>
        </div>
        <div class="cons" style="margin-top: 20px;">
          <ul class="service_chan">
            <li v-for="(item, index) in gene1" :key="index" class="pointer"  @click="$router.push(item.ref)">
              <div class="gene_img2">
                <img :src="`/static/img/hx_${item.img}${currentType===index ? '' : '_active'}.png`" style="width: 50px;height: 55px;">
              </div>
              <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
              <div class="liaojie" @click="$router.push(item.ref)">了解更多></div>
            </li>
          </ul>
        </div>
      </div>
        <div class="c-title">资源中心<small>Resource center</small></div>
        <div class="container mt30 mb30">
          <ul class="download">
            <li v-for="item in resourcesLists" :key="item.id">
              {{item.name}}
              <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
              <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

              <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
              <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
            </li>
          </ul>
        </div>
      <div class="container">
        <qk-consult type="Virus"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      currentType: -1,
      currentService: -1,
      types: [
        {name: 'DNA/RNA合成设备', img: '1', ref: '/intel/device_1'},
        {name: '合成配套设备 ', img: '2', ref: '/intel/device_2'},
        // {name: '小型实验设备 ', img: '3', ref: '/intel/device_3'},
        ],
      gene1: [
        {name: '基因合成',img: '1', ref: '/tec/gen_compose'},
        {name: '引物合成', img: '2',ref: '/tec/compose1'},
        {name: '修饰合成',img: '3', ref: '/equipment/Modified_synthesis'},
        // {name: '分子试剂',img: '4', ref: '/equipment/Molecular_reagent'},
        {name: '化学试剂' ,img: '6',ref: '/equipment/Chemical_Reagents'},
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/equipment/Instruments_equipment.vue